import { CalloutTypes } from 'rich-text-lib/constants/callout';
export const CALLOUT_ATTRIBUTE = 'data-hs-callout-type';
export const CALLOUT_ELEMENT = 'div';
export const CALLOUT_SELECTOR = `${CALLOUT_ELEMENT}[${CALLOUT_ATTRIBUTE}]`;
export const CALLOUT_TYPE_CLASS_PREFIX = 'hs-callout-type';
export const CALLOUT_CLASSES = Object.keys(CalloutTypes).map(calloutType => `${CALLOUT_TYPE_CLASS_PREFIX}-${calloutType}`).join(' ');